import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { CustomSelectInput } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
function CustomInput(innerProps) {
  var isDisabled = innerProps.isDisabled;
  return /*#__PURE__*/_jsx(CustomSelectInput, _extends({}, innerProps, {
    disabledStyling: isDisabled,
    isHidden: false
  }));
}
CustomInput.displayName = "CustomInput";
export default CustomInput;